"use client"

import { createContext, useContext, useState, ReactNode } from "react"
import { type UserInfo } from "@/types/user"

interface AuthContextType {
  user: UserInfo | null
  setUser: (user: UserInfo | null) => void
}

const AuthContext = createContext<AuthContextType | undefined>(undefined)

export function AuthProvider({ children, initialUser }: { children: ReactNode, initialUser: UserInfo | null }) {
  const [user, setUser] = useState<UserInfo | null>(initialUser)

  return (
    <AuthContext.Provider value={{ user, setUser }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  const context = useContext(AuthContext)
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider")
  }
  return context
}
